import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { MaplibreGL } from '@maplibre/maplibre-gl-leaflet';
import 'maplibre-gl/dist/maplibre-gl.css';

// The binding schedules a resize frame without cancelling it on removal.
// Cancel that frame so StrictMode and tab changes cannot access a removed map.
const ManagedMapLayer = MaplibreGL.extend({
  _transitionEnd() {
    L.Util.cancelAnimFrame(this._resizeFrame);
    this._resizeFrame = L.Util.requestAnimFrame(() => {
      if (!this._map || !this._glMap) return;
      const map = this._map;
      const gl = this._glMap;
      const offset = map.latLngToContainerPoint(map.getBounds().getNorthWest());
      this._resizeContainer();
      L.DomUtil.setTransform(gl.getCanvas(), offset, 1);
      gl.once('moveend', () => { if (this._map && this._glMap === gl) this._zoomEnd(); });
      gl.jumpTo({ center: map.getCenter(), zoom: map.getZoom() - 1 });
    });
  },
  onRemove(map) {
    L.Util.cancelAnimFrame(this._resizeFrame);
    return MaplibreGL.prototype.onRemove.call(this, map);
  },
});

// Keep Leaflet markers and interactions while rendering the shared vector basemap.
export default function OpenFreeMapLayer() {
  const map = useMap();
  useEffect(() => {
    const layer = new ManagedMapLayer({
      style: 'https://tiles.openfreemap.org/styles/positron',
      interactive: false,
      attributionControl: {
        customAttribution: '<a href="https://openfreemap.org/" target="_blank" rel="noopener noreferrer">OpenFreeMap</a> · © <a href="https://openmaptiles.org/" target="_blank" rel="noopener noreferrer">OpenMapTiles</a> · © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>',
      },
    });
    layer.addTo(map);
    const observer = new ResizeObserver(() => map.invalidateSize({ pan: false }));
    observer.observe(map.getContainer());
    return () => {
      observer.disconnect();
      map.removeLayer(layer);
    };
  }, [map]);
  return null;
}
